import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Link } from 'react-router-dom';
import { Alert, Form, FormGroup, Col, ControlLabel, Label, Button } from 'react-bootstrap';
import { Input, HtmlEditor, Select } from '../formControls';
import validators from '../../services/validators';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const EmailEditorForm = ({ error, handleSubmit, pristine, submitSucceeded, initialValues, showAllRecipients,
	onClickShowMoreLess, centers, onFromCenterChange, templates, templateId, appliedTemplateId, onApplyTemplate, tagCatalog, t }) => {
	const to = (initialValues && initialValues.to) || [];

	// Ad-hoc emails always resolve the default tag set (Franchisor/Parent/Center); the whole catalog
	// is added to the dropdown once and filtered to the default groups on open.
	const allTagGroups = (tagCatalog && tagCatalog.groups) || [];
	const defaultGroups = new Set((tagCatalog && tagCatalog.defaultGroups) || []);
	const applicableGroups = allTagGroups.filter(g => defaultGroups.has(g.group));
	const showCount = showAllRecipients ? to.length : 10;
	const recipients = [...to]
		.sort((a, b) => a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1)
		.slice(0, showCount).map(p =>
			<Label key={p.email} bsStyle='info' style={{ marginLeft: 5, lineHeight: 2.5 }}>{`${p.name} <${p.email}>`}</Label>
		);

	const more = to.length > 10 &&
		(showAllRecipients ? t('SendMessage_ShowLessRecipients') : `${t('SendMessage_ShowMoreRecipients', { count: to.length - showCount })}`);

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<FormGroup >
				<Col componentClass={ControlLabel} sm={2}>{t('SendMessage_To')}</Col>
				<Col sm={10} style={{ overflowWrap: 'break-word' }}>{recipients}  <Link onClick={onClickShowMoreLess}>{more}</Link></Col>
			</FormGroup>
			<Select name='fromCenterId' required horizontal hideEmptyOption label={t('MessageTemplate_From')} data={centers} validate={[validators.required]} onChange={(event, fromCenterId) => onFromCenterChange(fromCenterId)} />
			<Select name='templateId' horizontal label={t('MessageTemplate_Template')} data={templates} emptyLabel={t('MessageTemplate_TemplateSelect')}
				action={<Button bsStyle='success' disabled={templateId == appliedTemplateId} onClick={() => onApplyTemplate(templateId)}><FontAwesomeIcon icon={faCheck} /> {t('MessageTemplate_TemplateApply')}</Button>} />
			<Field name='subject' component={Input} horizontal required type='text' label={t('MessageTemplate_Subject')} validate={[validators.required]} />
			<Field name='body' component={HtmlEditor} horizontal required type='text' label={t('MessageTemplate_Body')} validate={[validators.required]}
				tagsEnabled tagAllGroups={allTagGroups} applicableGroups={applicableGroups} comboLabel={t('MessageTemplate_MergeTags')} />
		</Form>
	);
};

export default reduxForm({ form: 'sendMessage', enableReinitialize: true })(withTranslation()(EmailEditorForm));

export const selector = formValueSelector('sendMessage');